import { Injectable } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import {map, shareReplay, tap} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MediaQueryService {
  public isMobile: boolean = false;
  public mobileMediaQuery = this.breakpointObserver.observe(['(max-width: 640px)']).pipe(
    map((it) => it.matches),
    tap((it) => this.isMobile = it),
    tap((it) => {
      if (it) {
        document.body.classList.add('mobile')
      } else {
        document.body.classList.remove('mobile')
      }
    }),
    shareReplay(1),
  );

  constructor(public breakpointObserver: BreakpointObserver) {
    this.mobileMediaQuery.subscribe();
  }
}
